namespace Ir.Components.Workbook.Settings.Items.ColorSetting {
    export interface IColorSettingParams {
        value: KnockoutObservable<string>;
        disabled?: KnockoutObservable<boolean>;
        label?: string;
        appendTo?: any;
    }
    interface IViewModel {
        options: Ir.Components.General.ColorPicker.IColorPickerParams;
        label: string;
        disabled?: KnockoutObservable<boolean> | boolean;
    }

    interface IParams {
        config: IColorSettingParams;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        this.label = params.config.label ?? "Color";
        this.disabled = params.config.disabled === undefined ? false : params.config.disabled as any;
        this.options = {
            color: params.config.value,
            disabled: params.config.disabled,
            appendTo: params.config.appendTo
        }
    }
}